import { LinkProvider } from '../../../../../res/LinkProvider';
import React from 'react';


interface States {
}

interface Props {
}

export class QuickGuideButton extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <div>
                <a href={LinkProvider.quickGuide}>
                    <span className="quickGuideButton">
                        Quick Guide
                     </span>
                </a>
            </div>
        )
    }
}

export default QuickGuideButton;
